<template>
  <div id="app">
    <div v-if="isLoading">
      <div class="overlay">
        <div class="overlay__inner">
          <div class="overlay__content">
            <span class="spinner"></span>
          </div>
        </div>
      </div>
    </div>

    <offline @detected-condition="handleConnectivityChange">
      <!-- Only renders when the device is online 
    <div v-if="net_status == true" slot="online">
      <p>It looks like you're online! Here's all the things you can do...</p>
     
    </div>
    
    <div v-if="net_status == false" slot="offline">
      <p>You appear to be offline, that's okay, we can still do things...</p>
      
    </div>-->
    </offline>

    <b-modal id="modal-center" centered no-close-on-backdrop hide-header hide-footer>
      <p class="my-4"></p>

      <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1 1;
          flex-flow: column;
        ">
        <img :src="network" alt="" />

        <h3>No Internet Connection</h3>

        <p>Looks like you are offline. Please reconnect with Internet</p>

        <b-button block @click="handleConnectivityChange" style="background-color: #ffbb0e; color: #fff; margin: 20px">
          Retry</b-button>
      </div>
    </b-modal>

    <router-view />
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import offline from "v-offline";

import network from "../src/assets/images/32159-200.png";

export default {
  name: "App",
  data () {
    return {
      refCount: 0,
      isLoading: false,
      net_status: true,
      network,
    };
  },
  components: {
    offline,
  },
  methods: {
    setLoading (isLoading) {
      if (isLoading) {
        this.refCount++;
        this.isLoading = true;
      } else if (this.refCount > 0) {
        this.refCount--;
        this.isLoading = this.refCount > 0;
      }
    },
    handleConnectivityChange (status) {
      // console.log(status);

      this.net_status = status;

      if (this.net_status == false) {
        this.$bvModal.show("modal-center");

        // alert('net_status '+this.net_status)
      } else {
        this.$bvModal.hide("modal-center");
      }
    },
  },
  created () {
    axios.interceptors.request.use(
      (config) => {
        this.setLoading(true);

        return config;
      },
      (error) => {
        this.setLoading(false);
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        this.setLoading(false);

        return response;
      },
      (error) => {
        this.setLoading(false);
        return Promise.reject(error);
      }
    );
  },
  mounted () {
    this.$nextTick(function () {
      $(document).ready(function () {
        $(window).scroll(function () {
          // if ($(window).width() > 414) {
          /*   if ($(".location")[0]) {


                var content_location = $('.location').offset().top;
                if ($(window).scrollTop() + $(window).height() == $(document).height()) {
                    $('.cart_containt_item').height(290);
                } else if ($(window).scrollTop() >= content_location) {
                    $('.cart_containt_item').height($(window).height() - 234);
                } else {
                    $('.cart_containt_item').height(205);
                }
            }
            if ($(".search")[0]) {

                var content_menu = $('.search').offset().top;
                var auto = 200;
                if ($(window).scrollTop() + $(window).height() == $(document).height()) {
                    $('.main-nav-ul').height(460);
                } else if ($(window).scrollTop() >= content_menu) {
                    $('.main-nav-ul').height($(window).height(auto));
                } else {
                    $('.main-nav-ul').height($(window).height(auto));
                }
            }
*/
          //  }
        });
      });
    });
  },
};
</script>




<style>
.overlay {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background: #222;
  opacity: 0.9;
  z-index: 9999;
}

.overlay__inner {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.overlay__content {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.spinner {
  width: 75px;
  height: 75px;
  display: inline-block;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.05);
  border-top-color: #fff;
  animation: spin 1s infinite linear;
  border-radius: 100%;
  border-style: solid;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
